import { useEffect, useState } from 'react'
import { isValidResponseEntity } from '@helpers/utils';

const useHomePageDeal = ({
    homepageDealsResponse
}) => {
    const [homePageDeals, setHomePageDeals] = useState(homepageDealsResponse?.entity);
    // Handle errors if response is invalid
    const error = !isValidResponseEntity(homepageDealsResponse) ? Array.isArray(homepageDealsResponse?.message) ? homepageDealsResponse?.message?.[0] : homepageDealsResponse?.message : null;

    useEffect(() => {
        const isWindowDefined = typeof window !== 'undefined';
        const isWideScreen = isWindowDefined && window.innerWidth >= 768;
        
        // Only update the deals after the component is mounted (client-side)
        if (isWindowDefined) {
            const shouldDuplicateDeals = homepageDealsResponse?.entity?.length <= 3 && homepageDealsResponse?.entity?.length > 1 && isWideScreen;
            setHomePageDeals(shouldDuplicateDeals ? [...homepageDealsResponse.entity, ...homepageDealsResponse.entity] : homepageDealsResponse.entity);
        }
    }, []); 

    return {
        homePageDeals,
        error
    }
}

export default useHomePageDeal;